import { compose } from 'recompose';
import { connect } from 'react-redux';
import ShopList from '../components/ShopList';
import withLoading from '../../../common/withLoading';

const ShopListContainer = compose(
  connect(
    state => ({
      showLoading: state.admin.isFetching,
    })
  ),
  withLoading,
)(ShopList);

export default ShopListContainer;
